@if (showCloneType) {
  <fieldset class="mb-4">
    <legend class="nav-font16 font-weight-bold grey5 mb-2">What are you creating?</legend>
    <label class="d-flex align-items-start mb-2 cursor-pointer" [for]="idPrefix + 'Separate'">
      <input type="radio" [id]="idPrefix + 'Separate'" [name]="idPrefix + 'Type'" class="flex-shrink-0 mt-1 mr-2"
             [checked]="cloneType === 'separate'" (change)="choose('separate')" />
      <span>
        <span class="d-block nav-font14 grey6 font-weight-bold">New bid based on this one</span>
        <span class="d-block nav-font14 grey4">A separate bid, not linked to this tracker. Set a frequency to make it a new tracker, or Ad-hoc for a one-off.</span>
      </span>
    </label>
    <label class="d-flex align-items-start mb-2" [class.cursor-pointer]="!waveLocked" [for]="idPrefix + 'Wave'">
      <input type="radio" [id]="idPrefix + 'Wave'" [name]="idPrefix + 'Type'" class="flex-shrink-0 mt-1 mr-2"
             [disabled]="waveLocked" [checked]="cloneType === 'wave'" (change)="choose('wave')" />
      <span>
        <span class="d-block nav-font14 font-weight-bold" [ngClass]="waveLocked ? 'grey3' : 'grey6'">Next wave of this tracker</span>
        @if (waveLocked) {
          <span class="d-block nav-font14 grey4">Not available from 15 December to 15 January: a tracker's new year starts as a renewal.</span>
        } @else {
          <span class="d-block nav-font14 grey4">The next wave in this tracker year. Client sign-off isn't needed.</span>
        }
      </span>
    </label>
    <label class="d-flex align-items-start cursor-pointer" [for]="idPrefix + 'Renewal'">
      <input type="radio" [id]="idPrefix + 'Renewal'" [name]="idPrefix + 'Type'" class="flex-shrink-0 mt-1 mr-2"
             [checked]="cloneType === 'renewal'" (change)="choose('renewal')" />
      <span>
        <span class="d-block nav-font14 grey6 font-weight-bold">Renewal of this tracker</span>
        <span class="d-block nav-font14 grey4">Starts a new tracker year. The client approves full-year pricing again.</span>
      </span>
    </label>
    <!-- Opens in a new tab so Sales can check how it went and come back to the prompt. -->
    @if (cloneType !== 'separate' && sourceTrackerId && sourceBidId) {
      <a class="d-inline-block nav-font14 font-weight-bold mt-1" target="_blank" rel="noopener"
         [routerLink]="['/bids', sourceBidId]" [queryParams]="{ lastWave: cloneType === 'renewal' ? 'year' : 'wave' }">
        <i class="fas fa-chart-column mr-2" aria-hidden="true"></i>{{ cloneType === 'renewal' ? 'See how last year did against its full-year bid' : 'See how the last wave did against its bid' }}<span class="sr-only"> (opens in a new tab)</span>
        <i class="fas fa-arrow-up-right-from-square nav-font12 ml-1" aria-hidden="true"></i>
      </a>
    }
  </fieldset>
}

<!-- The imports read how a NAV project ran (the tracker's last wave, or the cloned bid's own project),
     so they're offered only once that project is found. A renewal copies last year's full year instead. -->
@if (asksFieldPlan) {
<fieldset [attr.aria-describedby]="idPrefix + 'PlanDetail'">
  <legend class="nav-font16 font-weight-bold grey5 mb-2">Where should the field plan come from?</legend>
  <label class="d-flex align-items-start mb-2 cursor-pointer" [for]="idPrefix + 'PlanBid'">
    <input type="radio" [id]="idPrefix + 'PlanBid'" [name]="idPrefix + 'Plan'" class="flex-shrink-0 mt-1 mr-2"
           [checked]="fieldPlanSource === 'bid'" (change)="pick('bid')" />
    <span>
      <span class="d-block nav-font14 grey6 font-weight-bold">Copy this bid's field plan</span>
      <span class="d-block nav-font14 grey4">The vendors and field plan as set up on bid #{{ sourceNumber }}.</span>
    </span>
  </label>
  <label class="d-flex align-items-start mb-2" [class.cursor-pointer]="plan" [for]="idPrefix + 'PlanStarted'">
    <input type="radio" [id]="idPrefix + 'PlanStarted'" [name]="idPrefix + 'Plan'" class="flex-shrink-0 mt-1 mr-2"
           [disabled]="!plan" [checked]="fieldPlanSource === 'started'" (change)="pick('started')" />
    <span>
      <span class="d-block nav-font14 font-weight-bold" [ngClass]="plan ? 'grey6' : 'grey3'">Import how {{ planSubject }} started</span>
      <span class="d-block nav-font14" [ngClass]="plan ? 'grey4' : 'grey3'">The vendors, allocations and CPIs, with the IR, LOI and client CPI, as set up when the first complete came in.</span>
    </span>
  </label>
  <label class="d-flex align-items-start" [class.cursor-pointer]="plan" [for]="idPrefix + 'PlanEnded'">
    <input type="radio" [id]="idPrefix + 'PlanEnded'" [name]="idPrefix + 'Plan'" class="flex-shrink-0 mt-1 mr-2"
           [disabled]="!plan" [checked]="fieldPlanSource === 'ended'" (change)="pick('ended')" />
    <span>
      <span class="d-block nav-font14 font-weight-bold" [ngClass]="plan ? 'grey6' : 'grey3'">Import how {{ planSubject }} ended</span>
      <span class="d-block nav-font14" [ngClass]="plan ? 'grey4' : 'grey3'">The vendors that delivered, with their completes as allocations and their final CPIs (fees included once closure is done), plus the actual IR, LOI and client CPI.</span>
    </span>
  </label>
  <p [id]="idPrefix + 'PlanDetail'" class="nav-font12 grey4 mt-2 mb-0">{{ planDetail }}@if (plan && fieldPlanSource === 'started' && startedResized) { Its set-up at the first complete isn't known, so the allocations as booked are sized to this bid's sample sizes.}</p>
</fieldset>
} @else {
  <p class="nav-font14 grey4 mb-0">The renewal starts from last year's full year: the option the client bought, with its field plan.</p>
}
@if (showCloneType && cloneType !== 'separate') {
  <p class="nav-font14 grey4 mt-3 mb-0">Field start and end dates are left blank.</p>
}
